<script lang="ts" setup>
import BasicInput from '~/components/form-elements/BasicInput.vue'
import { useSpecialistsStore } from '~/store/specialists'

const specialistsStore = useSpecialistsStore()

const emit = defineEmits<{
  (e: 'clear'): void
  (e: 'enter'): void
}>()
</script>

<template>
  <div class="relative">
    <BasicInput
      v-model="specialistsStore.filter.query"
      class="
        mr-4 w-full rounded-2xl [&_input]:!h-11 [&_input]:!bg-white [&_input]:text-sm placeholder:[&_input]:text-sm
        md:[&_input]:!h-14 md:[&_input]:!bg-main-gray-low md:[&_input]:text-base md:placeholder:[&_input]:text-base
      "
      :is-border="false"
      placeholder="Специальность, имя врача или услуга"
      @enter="emit('enter')"
    />

    <div class="absolute bottom-auto right-4 top-1/2 z-10 size-6 -translate-y-1/2">
      <a
        v-if="specialistsStore.filter.query.length > 0"
        href="#"
        @click.prevent="specialistsStore.filter.query = ''; emit('clear')"
      >
        <SvgIcon class="!size-6 fill-transparent" name="outlined/clear" />
      </a>
      <SvgIcon v-else class="!size-6 fill-transparent" name="outlined/new-search" />
    </div>
  </div>
</template>
